<template>
  <header :class="['header', 'panel', _isMobile() ? 'mobile' : '',]" :style="{'background':$route.meta.title == '首页' ? '#ffffff80' : '#fff'}">
    <div class="logo-bar">
      <a-row type="flex" justify="space-between" class="menu-up">
         <a-col :xs="0" :sm="0" :md="5" :lg="5" :xl="4" :xxl="4">
            <div class="logo">
              <img :src="logo ? logo : '/img/logo.png'" alt=""/>
            </div>
         </a-col>
        <a-col :xs="8" :sm="12" :md="10" :lg="13" :xl="14" :xxl="16" class="displayCenter">
          <div
            :class="['menu-bar', showMenu ? 'show' : 'hide', menuFixed?'menu-fixed':'']"
            @mouseleave="leave"
            @mouseover="over"
          >
          <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
          </div>

        </a-col>
        <a-col :xs="0" :sm="0" :md="6" :lg="6" :xl="5" :xxl="4">
          <div class="login-btn-wrap">
            <span class="user_info_box" v-if="$store.state.user.info">
              欢迎,<span  @click="toCenter" class="realnameBox" style="padding-right: 10px;font-weight: bold;">{{ $store.state.user.info.realname }}</span>
              <a-avatar v-if="$store.state.user.info"  @click="toCenter" icon="user" :src="avatarUrl" />
              <!-- <a-divider type="vertical" /> -->
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2' " type="vertical" />
              <span v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
        <a-col :xs="6" :sm="6" :md="0" :lg="0" :xl="0" :xxl="0">
          <span v-if="$store.state.user.info">
             <span  @click="toCenter" style="padding-right: 10px;font-weight: bold;">{{ $store.state.user.info.realname }}</span>
             <a-avatar v-if="$store.state.user.info"  @click="toCenter" icon="user" :src="avatarUrl" />
            </span>
        </a-col>
      </a-row>
    </div>
    <!-- <div class="float-menu">
          <div class="float-button" @click="scrollToTop" style="margin-bottom: 12px;">
            <i class="iconfont" style="font-size: 40px;padding-bottom: 10px;">&#xe6ab;</i>
            <div>回到顶部</div>
          </div>
          <div class="float-button" @click="AIChatStatus=true">
            <i class="iconfont" style="font-size: 28px;padding-bottom: 10px;">&#xe60a;</i>
            <div>AI助手</div>
          </div>
    </div> -->
    <AIChat v-if="AIChatStatus" @closeFn="AIChatStatus=false" />
  </header>
</template>
<script>
import Vue from "vue";
import { ACCESS_TOKEN,SYSTEM_INFO } from "@/store/mutation-types";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu"
import { jumpMixins } from "@/utils/jumpMixins"
import { putAction, postAction, getAction } from "@/api/manage";
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'
import AIChat from '@/components/tools/AIChat.vue';
export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TMenu,
    AIChat
  },
  data() {
    return {
      AIChatStatus:false,
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      menus: [],
      menuFixed: false,
      menuActive:'首页',
      tenantInfo: {},
      shareCode: ""
    };
  },
  watch:{
    '$route'(to, from) {
      console.log(to , 'to')
      this.menuActive = to.meta.title
    },
  },
  created() {
    if(this.$route.query.shareCode){
      this.onSearch(this.$route.query.shareCode)
    }
    this.menuActive = this.$route.meta.title
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.tenantInfo = this.$store.getters.tenantInfo
    let systemInfo = Vue.ls.get(SYSTEM_INFO)
    this.logo = systemInfo&&systemInfo.schoolLogo ? systemInfo.schoolLogo : this.tenantInfo.logo2
    this.menus = this.$store.getters.menuList
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.avatar){
        return this.$store.state.user.avatar
      }else if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        return this.$store.state.user.info.avatar
      }else{
        return "/img/avatar.png"
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    toCenter(){
      if(this.$store.state.user.info.userIdentity == 2){
            this.$router.push("/teacher")
        }else{
            this.$router.push("/user")
        }
    },
    onSearch(v) {
      if(!v) return
      let params = {id:v};
      getAction('/teaching/teachingSharingCode/queryByCodeId',params).then(res=>{
        if (res.success){
          window.open(res.result)
        }else {
          this.$message.error(res.message)
        }
      });
      console.log(v);

    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    openPageFn(title){
      console.log(title , 'title')
      // this.$set(this,'menuActive',title)
    },
    handleScroll(){
      let scrollTop = document.documentElement.scrollTop
      if (scrollTop >= 105) {
        this.menuFixed = true
      } else {
        this.menuFixed = false
      }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({name:'index'})
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    }
  },
};
</script>
<style>
.ant-menu-submenu-title{
  font-size: 24px;
}
 a::before{
      bottom:-2px !important;
    }
</style>
<style lang="less" scoped>
.user_info_box{
  display: flex;
  align-items: center;
  justify-content: center;
}
.realnameBox{
  display: inline-block;
  width: 80px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
}
.header{
  width: 100%;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 99;
  transition:  all 0.3 inherit;
  background: #ffffff80;
}
.displayCenter{
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-bar {
  width: auto !important;
  background: transparent;
  border-radius: 15px;
  z-index: 999;
  .menu {
    background: transparent;
    max-width: 1200px;
    margin: auto;
    /deep/.ant-menu-item > a,/deep/.ant-menu-submenu-title > a{
      background: transparent !important;
      // font-weight: 600;
      font-size: 18px;
    }
    /deep/.ant-menu-item-selected,/deep/.ant-menu-submenu-selected{
      background: transparent !important;
      border-radius: 0 !important;
    }
    /deep/.ant-menu-item-selected > a,/deep/.ant-menu-submenu-selected >.ant-menu-submenu-title > a {
      color: var(--primary-color) !important;
      font-weight: 600 !important;
      bottom:-2px !important;
    }
    /deep/.ant-menu-submenu-title a::before{
      bottom:-2px !important;
    }
    /deep/.ant-menu-submenu-title > .anticon-menu{
      color: #000 !important;
    }
  }
  .ant-menu-horizontal {
    border-bottom:none;
  }
}
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}
.logo-bar {
    width: 100%;
    max-width:1200px;
    margin: 0 auto;
  // border-bottom: 1px solid #f5f7fa;
  .menu-up {
    // height: 120px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    // height: 80px;
    .logo {
      margin-top: 5px;
      margin-right: 20px;
      img {
        display: inline-block;
        height: 50px !important;
        margin: 0 !important;
      }
      h2 {
        display: inline;
        font-style: italic;
        font-size: 20px;
        color: var(--primary-color);
        line-height: 30px;
        text-shadow: #b3b0b0ab 5px 3px 5px;
      }
    }
    .share-code{
      height: 100%;
      display: flex;
      align-items: center;
    }
    .login-btn-wrap {
      cursor: pointer;
      height: 100%;
      text-align: right;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: end;
      /deep/.ant-input{
        background-color: transparent;
        color: white;
      }
      /deep/.ant-input-suffix{
        i{
          color: rgba(255, 255, 255, 0.82);
        }
      }
      .ant-avatar {
        margin-right: 5px;
      }
      span {
        color: var(--primary-color);
      }
      .help {
        color: gray;
      }
    }
  }
}
@media only screen and (min-width: 1200px) {
  .menu-bar {
    width: 50%;
  }
}
@media only screen and (min-width: 781px) and (max-width: 1200px) {
   .menu-bar {
    width: 70%;
  }
}
@media only screen and (min-width: 581px) and (max-width: 780px){
   .menu-bar {
    width: 100%;
    // background: ;
  }
}
@media only screen and (max-width: 580px){
.menu-bar {
    width: 100%;
    background: transparent;}
}
</style>